import ZlbConfirm from '@/components/ZlbConfirm';
import {
  reqDepartments,
  reqList,
  reqUnbundle,
  asyncOfficailCard,
  getBindableOfficialCard,
  getUnavailableOfficialCard,
  getBoundOfficialCard,
} from '../services';


/**
 * 请求错误信息统一处理
 * @param res
 */
const responseErrorHandle = (res) => {
  const { success, statusText, message } = res;
  if (!success) {
    ZlbConfirm({
      title: statusText || message,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'businessCard',
  state: {
    tableQueryParams: {
      pageNo: 1,
      pageSize: 10,
    },
    departmentList: [],
    list: {},
  },
  effects: {
    // 所属部门
    * departments ({ payload }, { call, put }) {
      const res = yield call(reqDepartments, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          departmentList: res.result || [],
        },
      });
    },

    // 列表
    * fetchList ({ payload }, { call, put }) {
      const res = yield call(reqList, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          list: res.result,
          tableQueryParams: { ...payload },
        },
      });
      return res;
    },

    // 解绑公务卡
    * unbundle ({ payload }, { call }) {
      const res = yield call(reqUnbundle, payload);
      responseErrorHandle(res);
      return res;
    },
    // 同步公务卡
    * asyncOfficailCard ({ payload }, { call }) {
      const res = yield call(asyncOfficailCard, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取可绑定的公务卡
    * getBindableOfficialCard ({ payload }, { call }) {
      const res = yield call(getBindableOfficialCard, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取被其他人绑定的公务卡
    * getUnavailableOfficialCard ({ payload }, { call }) {
      const res = yield call(getUnavailableOfficialCard, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取已绑定的公务卡
    * getBoundOfficialCard ({ payload }, { call }) {
      const res = yield call(getBoundOfficialCard, payload);
      responseErrorHandle(res);
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
